var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoRatingStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04027 0.863165L8.09655 2.99035C8.24059 3.28042 8.62469 3.57049 8.94478 3.61884L10.8573 3.94114C12.0816 4.15064 12.3697 5.03696 11.4894 5.92329L10.0011 7.43005C9.75299 7.67983 9.60895 8.17134 9.68897 8.52587L10.1131 10.3872C10.4492 11.8536 9.67297 12.4257 8.38463 11.6602L6.59216 10.5886C6.26407 10.3952 5.73593 10.3952 5.40784 10.5886L3.60737 11.6522C2.31903 12.4177 1.54282 11.8456 1.87891 10.3791L2.30302 8.51781C2.38305 8.17134 2.23901 7.67983 1.99094 7.42199L0.510551 5.93135C-0.369681 5.04502 -0.0816053 4.15064 1.14272 3.9492L3.05522 3.6269C3.37531 3.57049 3.75941 3.28848 3.90345 2.99841L4.95972 0.871223C5.52787 -0.289061 6.47212 -0.289061 7.04027 0.863165Z",
    fill: "#CDD6E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoRatingStarEmpty);
export default __webpack_public_path__ + "static/media/trvto_rating-star-empty.f57bc676910b9b04c74053c859243fd5.svg";
export { ForwardRef as ReactComponent };